import React from 'react';
import { tscope } from '@i18n';
import { Csf } from '@assets/images';
import {
  Box,
  Text,
  Flex,
  Card,
  Button,
  Skeleton,
  useDisclosure,
} from 'ui';
import { DOCUMENT_TYPES, DocumentSection, UploadFormContainer } from '../components';
import { WorkFormModal } from '../components/WorkFormModal';
import { style as s } from './UploadProofOfBusiness.style';
import { useController } from './hooks';

export const ts = tscope('Documents.proofOfBusinessContent');

const type = DOCUMENT_TYPES.OPERATING_LICENSE;

export const UploadProofOfBusiness = () => {
  const {
    control,
    isLoading,
    clearField,
    onUploadError,
    workingSector,
    isWorkLoading,
    employmentName,
    workingActivity,
    onRemoveCompleted,
    onUploadCompleted,
    TaxSituationDocument,
    areDocumentsReady,
  } = useController();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <UploadFormContainer
      t={ts}
      imageElement={<Csf width="100%" height="100%" data-testid="image" />}
      type={type}
      areDocumentsReady={areDocumentsReady}
    >
      <WorkFormModal isOpen={isOpen} onClose={onClose} onCompleted={onClose} />
      <Skeleton
        isLoaded={!isWorkLoading}
        borderRadius="lg"
        marginBottom="5"
      >
        <Flex {...s.card}>
          <Box>
            <Text>{ts('occupation')}</Text>
            <Text {...s.text}>{employmentName}</Text>
            <Text {...s.text}>{workingSector}</Text>
            <Text {...s.text}>{workingActivity}</Text>
          </Box>
          <Button
            variant="link"
            onClick={onOpen}
          >
            {ts('change')}
          </Button>
        </Flex>
      </Skeleton>
      <Card>
        <DocumentSection
          t={ts}
          filesCount={100}
          control={control}
          name="taxSituation"
          isDisabled={isLoading}
          clearField={clearField}
          onUploadError={onUploadError}
          document={TaxSituationDocument}
          onUploadCompleted={onUploadCompleted}
          onRemoveCompleted={onRemoveCompleted}
        />
      </Card>
    </UploadFormContainer>
  );
};
